import React from 'react'
import { useParams } from 'react-router-dom'
import { defineMessage } from 'react-intl'
import { AppLayout } from '../../layouts/app'
import { NotificationDetail } from '../notification/detail/NotificationDetail'
import { translationsProject } from './translations/translationsProject'

const ProjectNotificationDetailPage: React.FC = () => {
  const { notificationId } = useParams<{ notificationId: string }>()

  return (
    <AppLayout
      title={{
        messageDescriptor: defineMessage(translationsProject.detailTitle),
      }}
    >
      <NotificationDetail id={notificationId as string} />
    </AppLayout>
  )
}

export { ProjectNotificationDetailPage }
